import React, { useLayoutEffect } from "react";
import { GlobeLifeLogo, LimitedIndemnityBrochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBLimitedIndemintyImage from "../../../../../assets/VEBPlanImages/VEBLimitedIndemnityImage.avif";
import "./limitedIndemnity.scss";

const LimitedIndeminity: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="limited-indemnity-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Group Limited Indemnity</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={GlobeLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							Our Group Limited Indemnity (GLI) insurance helps cover the cost of certain expenses
							incurred due to a covered accident or sickness. Benefits are payable at a fixed amount per
							insured per day up to a maximum number of days per year.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							GLI coverage is easy to use. Once enrolled, you’ll receive an ID card to present to your
							medical provider at the time of service. Your provider can submit the claim on your behalf.
							Once that claim is processed and approved, we’ll pay the benefit directly to your provider.
							If you prefer not to assign benefits to your provider, you may submit a copy of the itemized
							bill to us directly. We will pay the benefit directly to you, and you will be responsible to
							pay your provider.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBLimitedIndemintyImage} alt="VEBLimitedIndemintyImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={LimitedIndemnityBrochure} />
			</div>
		</div>
	);
};

export default LimitedIndeminity;
